<script setup>
import PageHeader from '@/components/PageHeader.vue';
import Dashboard from './Home/Dashboard.vue'
import StandingsType from './Home/StandingsType.vue'
import { useRoute } from 'vue-router'

import { ref, watch } from 'vue'

const route = useRoute()
const allowedTypes = ['overall', 'month', 'week']
const type = ref(route.params.type)

// Se timeframe non è definito, usa il mese corrente in formato YYYYMM
const getDefaultTimeframe = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  return `${year}${month}`
}

const timeframe = ref(route.params.timeframe || getDefaultTimeframe())
const showType = ref(allowedTypes.includes(type.value))

watch(() => route.params.type, (newType) => {
  type.value = newType
  showType.value = allowedTypes.includes(newType)
  timeframe.value = route.params.timeframe || getDefaultTimeframe()
})

watch(() => route.params.timeframe, (newTimeframe) => {
  timeframe.value = newTimeframe || getDefaultTimeframe()
})
</script>


<template>
  <v-container fluid>
    <template v-if="showType">
      <StandingsType :type="type" :timeframe="timeframe" />
    </template>
    <template v-else>
      <PageHeader :title="$t('standings.title')" icon="mdi-trophy" />
      <Dashboard />
    </template>
  </v-container>
</template>


<style scoped>
.v-container {
  max-width: 1200px;
}
</style>